import { UnderMaintenance } from 'components/under-maintenance/UnderMaintenance'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useFetch } from 'services/useFetch'
import { API } from 'services/api'

export const UnderMaintenanceContainer = () => {
    const navigate = useNavigate()
    const { errorData } = useSelector((state) => state.homeReducer)
    const { fetching: getHome } = useFetch(API.HOME)

    const onReload = () => {
        window.location.reload()
    }

    useEffect(() => {
        if (!errorData?.title) {
            getHome().then(() => {
                navigate('/')
            })
        }
    }, [])

    const props = {
        errorData,
        onReload,
    }

    return <UnderMaintenance {...props} />
}
